const initialState = {
  sportsCommunityBadge: [],
};

const SportsCommunityBadgeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SPORTS_COMMUNITY_BADGE":
      return {
        ...state,
        sportsCommunityBadge: action.payload,
      };
    default:
      return state;
  }
};

export default SportsCommunityBadgeReducer;
